import { observer } from 'mobx-react';

import SecuredPage from 'Views/Components/Security/SecuredPage';
import Navbar from 'Views/Components/Navbar/Navbar';

import useStore from 'Hooks/useStore';

import StudyPlanCollection from 'Views/Components/StudyPlanCollection/StudyPlanCollection';
import Spinner from 'Views/Components/Spinner/Spinner';
import { toLower } from 'lodash';

const HomePage = observer(() => {
	const store = useStore();
	const isStudent = store.userGroups.map(ug => ug.name).includes('User');

	if (!store.userId) {
		return <Spinner />;
	}

	return (
		<SecuredPage
			groups={[
				'Super Administrators',
				'Admin',
				'InstitutionAdmin',
				'StudentAdvisor',
				'CurriculumSupport',
				'User',
			]}
		>
			<div className="body-content">
				<Navbar
					hideNavButtons={isStudent}
				/>
				<main className="study-plans-page">
					<StudyPlanCollection
						title={`My ${toLower(window.lexicon.studyPlans)}`}
						userId={store.userId}
						studentView={isStudent}
						canDelete
						showActiveToggle={isStudent}
					/>
				</main>
			</div>
		</SecuredPage>
	);
});

export default HomePage;
